(()=>{
    angular.module('omc').directive('disabledInput', contentTitleDirective)
    function contentTitleDirective($interpolate){
        return {
            restrict: "A",
            link: function ($scope, $element, iAttrs) {
                $($element).addClass('disabled-input')
                $element.on('mouseover',()=>{
                    let innerText = $interpolate($element.text().trim().replace(/\s+/g,' '))($scope)
                    iAttrs.$set('title',innerText)
                })
            }
        }
    }
})()
